;(function () {
  var CHOICE_KEY = 'tt_location_confirm'
  var THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000
  var STORE_LABELS = {
    'transformertable.com': 'United States',
    'ca.transformertable.com': 'Canada',
    'uk.transformertable.com': 'United Kingdom',
    'fr.transformertable.com': 'France',
    'ger.transformertable.com': 'Germany',
    'eu.transformertable.com': 'Europe',
    'sg.transformertable.com': 'Singapore',
    'aus.transformertable.com': 'Australia',
    'gcc.transformertable.com': 'Middle East',
    'row.transformertable.com': 'International',
  }
  var GCC_ALIASES = { BH: true, OM: true }

  function normalizeHost(host) {
    return String(host || '')
      .replace(/^www\./i, '')
      .split('/')[0]
      .toLowerCase()
  }

  function stores() {
    return (window.internationalization && window.internationalization.stores) || []
  }

  function storeByMarket(code) {
    var wanted = String(code || '').toUpperCase()
    if (!wanted) return null
    var list = stores()
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].shopifyMarket || '').toUpperCase() === wanted) return list[i]
    }
    return null
  }

  function storeByHost(host) {
    var wanted = normalizeHost(host)
    var list = stores()
    for (var i = 0; i < list.length; i++) {
      if (normalizeHost(list[i].domain) === wanted) return list[i]
    }
    return null
  }

  function currentStore(card) {
    return storeByHost(window.location.hostname) || storeByMarket(card.getAttribute('data-store-country'))
  }

  function storeLabel(store) {
    if (!store) return ''
    return STORE_LABELS[normalizeHost(store.domain)] || ''
  }

  function suggestedStore(countryCode) {
    var code = String(countryCode || '').toUpperCase()
    var match = storeByMarket(code)
    if (!match && GCC_ALIASES[code]) match = storeByHost('gcc.transformertable.com')
    if (!match) match = storeByHost('row.transformertable.com')
    return match
  }

  function namesMatch(label, country) {
    return String(label || '').toLowerCase() === String(country || '').toLowerCase()
  }

  function localePrefix(hostname, pathname) {
    var host = normalizeHost(hostname)
    var list = stores()
    var best = ''
    for (var i = 0; i < list.length; i++) {
      var languages = list[i].languages || []
      for (var j = 0; j < languages.length; j++) {
        var url = languages[j].url || ''
        var slash = url.indexOf('/')
        var languageHost = normalizeHost(slash === -1 ? url : url.slice(0, slash))
        var prefix = slash === -1 ? '' : url.slice(slash)
        if (!prefix || languageHost !== host) continue
        if (pathname === prefix || pathname.indexOf(prefix + '/') === 0) {
          if (prefix.length > best.length) best = prefix
        }
      }
    }
    return best
  }

  function suggestedHref(store) {
    var host = normalizeHost(store.domain)
    var path = window.location.pathname || '/'
    var prefix = localePrefix(window.location.hostname, path)
    if (prefix && (path === prefix || path.indexOf(prefix + '/') === 0)) {
      path = path.slice(prefix.length) || '/'
    }
    if (path.charAt(0) !== '/') path = '/' + path
    return 'https://' + host + path + window.location.search + window.location.hash
  }

  function isBot() {
    var ua = navigator.userAgent || ''
    return /bot\b|crawl|spider|slurp|bingpreview|facebookexternalhit|embedly|baiduspider|yandex|sogou|duckduckbot|semrush|ahrefs|petalbot|bytespider|gptbot|claudebot|amazonbot|google-inspectiontool|adsbot|mediapartners/i.test(
      ua
    )
  }

  function hasChoice() {
    var parts = document.cookie ? document.cookie.split(';') : []
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].trim().indexOf(CHOICE_KEY + '=') === 0) return true
    }
    try {
      var saved = JSON.parse(localStorage.getItem(CHOICE_KEY) || 'null')
      if (saved && saved.at && Date.now() - saved.at < THIRTY_DAYS_MS) return true
    } catch (error) {}
    return false
  }

  function rememberChoice() {
    document.cookie =
      CHOICE_KEY + '=1; path=/; max-age=' + Math.floor(THIRTY_DAYS_MS / 1000) + '; SameSite=Lax'
    try {
      localStorage.setItem(CHOICE_KEY, JSON.stringify({ at: Date.now() }))
    } catch (error) {}
  }

  function track(eventName, extra) {
    var detail = extra || {}
    window.dataLayer = window.dataLayer || []
    var payload = { event: eventName }
    for (var key in detail) {
      if (Object.prototype.hasOwnProperty.call(detail, key)) payload[key] = detail[key]
    }
    window.dataLayer.push(payload)
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish(eventName, detail)
    }
  }

  function readCache() {
    try {
      return JSON.parse(sessionStorage.getItem('geoLocation') || 'null')
    } catch (error) {
      return null
    }
  }

  function openSuggested(anchor) {
    var target = anchor.getAttribute('href')
    if (!target) return
    window.location.assign(anchor.href)
  }

  function init() {
    if (isBot() || hasChoice()) return
    var card = document.getElementById('LocationConfirm')
    if (!card) return

    var opened = false

    card.addEventListener('click', function (event) {
      var stay = event.target.closest('[data-location-action="stay"]')
      var dismiss = event.target.closest('[data-location-action="dismiss"]')
      var suggested = event.target.closest('[data-location-action="suggested"]')
      if (stay || dismiss) {
        event.preventDefault()
        rememberChoice()
        card.setAttribute('hidden', '')
        track('location_confirm_stay', { method: stay ? 'current_store' : 'close' })
        return
      }
      if (!suggested) return
      event.preventDefault()
      rememberChoice()
      track('location_confirm_suggested', {
        suggested_store: suggested.hostname || '',
      })
      openSuggested(suggested)
    })

    function show(geo) {
      if (opened || !geo) return
      if (!window.internationalization || !window.internationalization.stores) return
      var countryCode = geo.countryCode || geo.country_code
      if (!countryCode) return
      var current = currentStore(card)
      var suggested = suggestedStore(countryCode)
      if (!current || !suggested) return
      if (normalizeHost(current.domain) === normalizeHost(suggested.domain)) return

      var currentButton = card.querySelector('[data-location-label="current"]')
      var suggestedLink = card.querySelector('[data-location-label="suggested"]')
      if (!currentButton || !suggestedLink) return

      var suggestedName = storeLabel(suggested)
      currentButton.textContent = storeLabel(current)
      suggestedLink.textContent = suggestedName
      suggestedLink.setAttribute('href', suggestedHref(suggested))

      if (!namesMatch(suggestedName, geo.country)) {
        var countryName = card.querySelector('[data-location-country]')
        if (countryName) countryName.textContent = geo.country || ''
        var captions = card.querySelectorAll('[data-location-caption]')
        for (var i = 0; i < captions.length; i++) captions[i].removeAttribute('hidden')
      }
      card.removeAttribute('hidden')
      opened = true
      track('location_confirm_shown', {
        current_store: normalizeHost(current.domain),
        suggested_store: normalizeHost(suggested.domain),
        visitor_country: geo.countryCode || geo.country_code || '',
      })
    }

    function whenReady(callback) {
      if (window.internationalization && window.internationalization.stores) {
        callback()
        return
      }
      var tries = 0
      var timer = setInterval(function () {
        tries += 1
        if ((window.internationalization && window.internationalization.stores) || tries > 50) {
          clearInterval(timer)
          callback()
        }
      }, 100)
    }

    whenReady(function () {
      var cached = readCache()
      if (cached && cached.countryCode) {
        show(cached)
        return
      }
      document.addEventListener('set:geolocation', function (event) {
        show((event && event.detail) || null)
      })
    })
  }

  if (typeof document !== 'undefined') init()
})()
